import {useState, useEffect} from "react";

export const useTypewriter = (
  words,
  {loop = true, typeSpeed = 100, deleteSpeed = 50, delay = 1500} = {}
) => {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(typeSpeed);

  useEffect(() => {
    const handleType = () => {
      const i = loopNum % words.length;
      const fullText = words[i];

      setText(
        isDeleting
          ? fullText.substring(0, text.length - 1)
          : fullText.substring(0, text.length + 1)
      );

      setTypingSpeed(isDeleting ? deleteSpeed : typeSpeed);

      if (!isDeleting && text === fullText) {
        if (!loop && loopNum === words.length - 1) return;
        setTimeout(() => setIsDeleting(true), delay);
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [
    text,
    isDeleting,
    loopNum,
    words,
    loop,
    typeSpeed,
    deleteSpeed,
    delay,
    typingSpeed
  ]);

  return text;
};
